import { render, staticRenderFns } from "./PermissionSetting.vue?vue&type=template&id=c328507e&scoped=true&"
import script from "./PermissionSetting.vue?vue&type=script&lang=js&"
export * from "./PermissionSetting.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSetting.vue?vue&type=style&index=0&id=c328507e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c328507e",
  null
  
)

export default component.exports